const Envelope = () => {
  return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_34_183)">
          <path
            d="M19 0.999756H5C3.67441 1.00134 2.40356 1.52864 1.46622 2.46598C0.528882 3.40331 0.00158786 4.67416 0 5.99976L0 17.9998C0.00158786 19.3254 0.528882 20.5962 1.46622 21.5335C2.40356 22.4709 3.67441 22.9982 5 22.9998H19C20.3256 22.9982 21.5964 22.4709 22.5338 21.5335C23.4711 20.5962 23.9984 19.3254 24 17.9998V5.99976C23.9984 4.67416 23.4711 3.40331 22.5338 2.46598C21.5964 1.52864 20.3256 1.00134 19 0.999756ZM5 2.99976H19C19.5988 3.00093 20.1835 3.18127 20.679 3.51756C21.1744 3.85385 21.5579 4.3307 21.78 4.88676L14.122 12.5458C13.5584 13.1071 12.7954 13.4222 12 13.4222C11.2046 13.4222 10.4416 13.1071 9.878 12.5458L2.22 4.88676C2.44215 4.3307 2.82561 3.85385 3.32105 3.51756C3.81648 3.18127 4.40121 3.00093 5 2.99976ZM19 20.9998H5C4.20435 20.9998 3.44129 20.6837 2.87868 20.1211C2.31607 19.5585 2 18.7954 2 17.9998V7.49976L8.464 13.9598C9.40263 14.896 10.6743 15.4218 12 15.4218C13.3257 15.4218 14.5974 14.896 15.536 13.9598L22 7.49976V17.9998C22 18.7954 21.6839 19.5585 21.1213 20.1211C20.5587 20.6837 19.7956 20.9998 19 20.9998Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_34_183">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};

export default Envelope;